import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PlanType } from "../../types/PlansType"
import { GET_ADD_PLANS_URL, GET_UPDATE_DELETE_PLAN_URL } from "../../constants/api/endpoints"
import { http } from "../../utils/http"
import { AxiosResponse } from "axios"
import { PlanFormType } from "../../types/api/plan"


// Todo review the response from the update an the create function

// Fetch all plans
export const fetchPlans = createAsyncThunk("plan/fetchPlans", async (_, thunkApi) => {
  return http
    .get<PlanType[]>(GET_ADD_PLANS_URL)
    .then((res): PlanType[] => res.data)
    .catch(e => {
      return thunkApi.rejectWithValue({ data: e.data })
    })
})

// Create a plan
export const createAsyncPlan = createAsyncThunk<PlanType, PlanFormType>(
  "plan/createAsyncPlan",
  async (plan: Partial<PlanFormType>, thunkApi) => {
    return http
      .post<PlanType>(GET_ADD_PLANS_URL, plan)
      .then((res): PlanType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Update an existing plan
export const updateAsyncPlan = createAsyncThunk<PlanType, {
  id?: string,
  data?: Partial<PlanFormType | FormData>,
}>(
  "plan/updateAsyncPlan",
  async ({ id, data }: {
    id?: string,
    data?: Partial<PlanFormType | FormData>,
  }, thunkApi) => {
    return http
      .patch<PlanType>(GET_UPDATE_DELETE_PLAN_URL.replace(":id", `${id}`), data)
      .then((res): PlanType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Delete an existing plan
export const deleteAsyncPlan = createAsyncThunk<AxiosResponse, { id: string }>(
  "plan/deleteAsyncPlan",
  async ({ id }: { id: string }, thunkApi) => {
    return http
      .delete<AxiosResponse>(GET_UPDATE_DELETE_PLAN_URL.replace(":id", id))
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)
const initialPlanState =[
  {
    "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
    "options": [],
    "is_deleted": false,
    "deleted_at": null,
    "name": "STANDARD",
    "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
    "base_price": null,
    "price_by_collabo": null,
    "status": "ACTIVE"
  },
  {
    "id": "b9340ab9-ea4e-445f-adee-e10333e9f733",
    "options": [],
    "is_deleted": false,
    "deleted_at": null,
    "name": "CUSTOM",
    "description": "Pour les startups qui ont plus de 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
    "base_price": null,
    "price_by_collabo": null,
    "status": "ACTIVE"
  },
  {
    "id": "e49fc20e-4c5e-46af-87d3-3d902661f01b",
    "options": [],
    "is_deleted": false,
    "deleted_at": null,
    "name": "STARTER",
    "description": "Pour les startups qui ont moins de 10 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
    "base_price": null,
    "price_by_collabo": null,
    "status": "ACTIVE"
  },
  {
    "id": "a347a3ce-bf6b-49ed-ae92-7fe69b6eace3",
    "options": [],
    "is_deleted": false,
    "deleted_at": null,
    "name": "Extra Plan",
    "description": "Our best plan",
    "base_price": 1000,
    "price_by_collabo": 50,
    "status": "ACTIVE"
  },
  {
    "id": "35c96700-b630-4209-9fd4-f7af1b0e1b2b",
    "options": [
      {
        "id": "b1d2e3f4-5a6b-4c7d-9e8f-0a1b2c3d4e5f",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Facturation",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      },
      {
        "id": "c6d7e8f9-0a1b-4c2d-8e3f-4a5b6c7d8e9f",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Gestion des accès",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      }
    ],
    "is_deleted": false,
    "deleted_at": null,
    "name": "Small Plan",
    "description": "....",
    "base_price": 2000,
    "price_by_collabo": 60,
    "status": "ACTIVE"
  },
  {
    "id": "7ad9a66c-d6a3-48a5-868e-bdb2d8a8e3d7",
    "options": [
      {
        "id": "b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Profils des collaborateurs",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      },
      {
        "id": "d4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f8a",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Registre du personnel",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      },
      {
        "id": "e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8a9b",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Organigramme des collaborateurs",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      },
      {
        "id": "f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Validation des demandes d'absences",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      },
      {
        "id": "f2a3b4c5-d6e7-4f8a-9b0c-1d2e3f4a5b6c",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Planning des congés et absences",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      },
      {
        "id": "a1e8b3c4-5d9f-4e0a-a1b2-c3d4e5f6a7b8",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Virements bancaires des salaires",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      },
      {
        "id": "d5a6b7c8-9d0e-4f1a-b2c3-d4e5f6a7b8c9",
        "is_deleted": false,
        "deleted_at": null,
        "label": "Écritures comptables",
        "amount": 0,
        "type": "DEFAULT",
        "is_active": true
      }
    ],
    "is_deleted": false,
    "deleted_at": null,
    "name": "Medium Plan",
    "description": "---",
    "base_price": 0,
    "price_by_collabo": 0,
    "status": "ACTIVE"
  }
]



// initial state
const initialState: {
  plans: PlanType[],
  plansStatus: string,
  plansErrors?: any,

  addPlanStatus: string,
  addPlanErrors?: any,

  deletePlanErrors?: any,
  deletePlanStatus: string,
} = {
  plans: initialPlanState,
  plansStatus: "idle",
  addPlanStatus: "idle",
  deletePlanStatus: "idle",
}

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {},

  extraReducers(builder) {
    // get  all plans
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.plansStatus = "loading"
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.plansStatus = "succeeded"
        state.plans = action.payload
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.plansStatus = "failed"
        state.plansErrors = action.error
      })

    builder
      .addCase(createAsyncPlan.pending, (state) => {
        state.addPlanStatus = "loading"
      })
      .addCase(createAsyncPlan.fulfilled, (state, action) => {
        state.addPlanStatus = "succeeded"
        state.plans = [action.payload, ...state.plans ]

      })
      .addCase(createAsyncPlan.rejected, (state, action) => {
        state.addPlanStatus = "failed"
        state.addPlanErrors = action.error
      })

    builder
      .addCase(updateAsyncPlan.pending, (state) => {
        state.plansStatus = "loading"
      })
      .addCase(updateAsyncPlan.fulfilled, (state, action) => {
        state.plansStatus = "succeeded"
        let index = state.plans.findIndex(plan => plan.id === action.meta.arg.id)
        state.plans[index] = action.payload
        // if (index >= 0) {
        //   state.plans.splice(index, 1)
        //   state.plans.reverse()
        //   state.plans.unshift(action.payload)
        //   state.plans.reverse()
        // }

      })
      .addCase(updateAsyncPlan.rejected, (state, action) => {
        state.plansStatus = "failed"
        state.plansErrors = action.error
      })

    builder
      .addCase(deleteAsyncPlan.pending, (state) => {
        state.deletePlanStatus = "loading"
      })
      .addCase(deleteAsyncPlan.fulfilled, (state, action) => {
        state.plansStatus = "succeeded"
        state.plans = state.plans.filter((plan) => plan.id !== action.meta.arg.id)
      })
      .addCase(deleteAsyncPlan.rejected, (state, action) => {
        state.deletePlanStatus = "failed"
        state.deletePlanErrors = action.error
      })

  },
})

export default plansSlice.reducer

